import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { cardImage } from "../../domain/shopImages";
import { Avatar } from "../../themeV2";
import { getInitials } from "../../util/text";
import css from "./ShopCardImage.module.css";

const imagePropType = PropTypes.shape({
  url: PropTypes.string.isRequired,
  squareUrl: PropTypes.string,
});

export default function ShopCardImage({
  source,
  name,
  width,
  height,
  loading = "lazy",
  className,
  style,
  decorative = false,
}) {
  const { main, overlay, mainLabel } = cardImage(source);

  return (
    <span className={clsx(css.root, className)} style={style}>
      {main ? (
        <img
          className={css.main}
          src={main}
          alt={decorative ? "" : mainLabel ?? ""}
          width={width}
          height={height}
          loading={loading}
        />
      ) : (
        <span className={css.fallback} aria-hidden="true">
          {getInitials(name)}
        </span>
      )}
      {overlay && <Avatar className={css.overlay} src={overlay} size="md" />}
    </span>
  );
}

ShopCardImage.propTypes = {
  source: PropTypes.shape({
    headshot: imagePropType,
    primaryCharacter: PropTypes.shape({
      url: PropTypes.string.isRequired,
      squareUrl: PropTypes.string,
      label: PropTypes.string,
      characterName: PropTypes.string,
      franchiseName: PropTypes.string,
    }),
  }).isRequired,
  name: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  loading: PropTypes.oneOf(["lazy", "eager"]),
  className: PropTypes.string,
  style: PropTypes.object,
  decorative: PropTypes.bool,
};
